import { Link } from 'react-router-dom';
import { APISERVERURL } from '../APIServerURL';

const EventCard = ({ post }) => {
  const to = `/editevent/${post._id}`;
  const imgName = post.images && post.images.length > 0 ? post.images[0] : 'default.png';
  
  function formatDbDate(dbDate) {
    if (!dbDate || typeof dbDate !== 'string' || !dbDate.includes('-')) {
        return 'dd-mm-yyyy';
    }
    
    let parts = dbDate.split("-");
    if (parts.length !== 3 || parts.some(part => isNaN(part) || part.length === 0)) {
        return 'dd-mm-yyyy';
    }
    
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
}
  return (
    <Link
  to={to}
  className="w-[300px] h-[400px] bg-white shadow-lg rounded-2xl overflow-hidden hover:shadow-2xl hover:scale-105 transition-transform duration-300 relative"
>
<div className="relative w-full h-[300px]">
  {/* Image div */}
  <div className="w-full h-full overflow-hidden">
    <img
      src={`${APISERVERURL}/eventimg/${imgName}`}
      alt="placeholder"
      className="w-full h-full object-cover transform hover:scale-110 transition-transform duration-500"
    />
  </div>

  {/* Top overlay div */}
  <div className="absolute top-0 left-0 w-full h-full z-10 bg-black/50 flex items-center justify-center hover:bg-black/10">
  <div className='width-full height-full flex flex-col justify-center items-center'>
     <span className="text-white text-xl">{post.images.length}</span>    
     <span className="text-white text-xs">PHOTOS</span>    
  </div>
    
  </div>
</div>

  <div className="w-full h-[100px] flex flex-col justify-center items-center overflow-y-auto p-1 text-xs bg-blue-100  transition-colors duration-300 hover:bg-blue-600 hover:text-white">
  <p className="font-semibold mb-2">{post.name.toUpperCase()}</p>
  
  <p className='m-1'>{`Published:${post.publishInWebsite}`}</p>
  <p className='m-1'>{`${formatDbDate(post.ondate)}`}</p>
</div>
</Link>


  );
};

export default EventCard;
